<template>
  <div class="error-logs-view flex flex-col">
    <page-header :title="tr('Error log')" />
    <error-logs />
  </div>
</template>

<script>
import ErrorLogs from '@/ui/components/ErrorLogs.vue';
import PageHeader from '@/ui/components/PageHeader.vue';

export default {
  name: 'ErrorLogsView',
  components: {
    ErrorLogs,
    PageHeader,
  },
};
</script>
